import React, { useEffect, useState } from "react";

const ConnectReturn = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1024px)");
    const apply = () => setIsSmallScreen(mq.matches);
    apply();
    mq.addEventListener?.("change", apply);
    return () => mq.removeEventListener?.("change", apply);
  }, []);

  return (
    <div style={{ ...styles.outerWrap, ...(isSmallScreen ? styles.outerWrapCompact : null) }}>
      <div style={{ ...styles.card, ...(isSmallScreen ? styles.cardWide : null) }}>
        <h2 style={styles.title}>Stripe Onboarding Submitted</h2>

        <p style={styles.text}>
          Thank you. Your payout onboarding information has been submitted.
        </p>

        <p style={styles.text}>
          Our team will review your payout setup and continue processing your influencer account.
        </p>

        <p style={styles.subtle}>
          You may now close this page and return to AskLawly.
        </p>

        <div style={styles.buttonRow}>
          <a href="/home" style={styles.primaryButton}>
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

const styles = {
  outerWrap: {
    maxWidth: 960,
    margin: "24px auto",
    padding: "0 16px 40px",
  },
  outerWrapCompact: {
    padding: "0 8px 40px",
  },
  card: {
    maxWidth: 520,
    margin: "0 auto",
    padding: 28,
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 12,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    fontFamily: "sans-serif",
    textAlign: "center",
  },
  cardWide: {
    maxWidth: 560,
  },
  title: {
    fontSize: 26,
    fontWeight: "bold",
    marginBottom: 18,
    color: "#111827",
  },
  text: {
    color: "#334155",
    fontSize: 15,
    lineHeight: 1.65,
    margin: "0 0 12px",
  },
  subtle: {
    color: "#64748b",
    fontSize: 13,
    marginTop: 6,
  },
  buttonRow: {
    marginTop: 22,
    display: "flex",
    justifyContent: "center",
  },
  primaryButton: {
    display: "inline-block",
    padding: "12px 18px",
    fontSize: 16,
    backgroundColor: "#1E2A78",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    textDecoration: "none",
    fontWeight: 700,
  },
};

export default ConnectReturn;
